import { Backdrop, Box, CircularProgress } from '@mui/material';
import { useAppContext } from '../../../Helpers/Contexts/AppContext';
import "./SimpleBackdrop.css";

// Styles
const styles = {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    top: "50%",
    left: "50%",
    width: "30vw",
    transform: "translate(-50%, -50%)",
};

export default function SimpleBackdrop() {
    // App Context
    const [appContext] = useAppContext();

    // Component
    return (
        <Backdrop
            sx={{ zIndex: 9999 }}
            open={appContext.simpleBackdropOpened}
        >
            <Box style={styles}>
                <Box sx={{ display: "flex" }} justifyContent="center">
                    <CircularProgress color="contrast" sx={{ width: "100%", opacity: "0.8" }} />
                </Box>
            </Box>
        </Backdrop>
    );
}
